import { getApiOrigin } from './apiConfig';

export const getApiBaseUrl = () => getApiOrigin();

export const resolveAssetUrl = (path?: string | null): string | undefined => {
  if (!path) return undefined;
  
  // If already a full URL, return as-is
  if (/^https?:\/\//i.test(path)) {
    return path;
  }
  
  // Build full URL from relative path
  const base = getApiBaseUrl();
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  return `${base}${cleanPath}`;
};
